// Der EINE Kippschalter des Webclients (Ein/Aus).
//
// WOFUER: bisher gab es vier handgeschriebene Kopien (AiSettingsSection,
// UsersSection, LinkedRepositoriesSection, GitAdminSection) und in den
// Einstellungen ein Ankreuzkaestchen. Diese Komponente ist die gemeinsame
// Form fuer neue Stellen; die vorhandenen Kopien sind (noch) nicht umgestellt.
//
// - Natives <button role="switch" aria-checked>: Leertaste und Enter loesen
//   den Klick aus, ohne eigenen Tastatur-Code.
// - Tippflaeche: auf schmalen Fenstern 44x44 px (die sichtbare Spur bleibt
//   klein), ab `sm` nur die Spur.
// - Fokusring an der Spur (sichtbar auch, wenn die Tippflaeche groesser ist).
// - Farben nur ueber Tokens: An = primary, Aus = surface-container-high mit
//   outline-Rand (Spur bleibt auf jeder Flaeche erkennbar, >= 3:1).

import type { JSX } from "preact";

export interface SwitchProps {
  checked: boolean;
  onChange: (next: boolean) => void;
  disabled?: boolean;
  /** Pflicht, wenn kein sichtbares <label for> / aria-labelledby existiert. */
  "aria-label"?: string;
  "aria-labelledby"?: string;
  "aria-describedby"?: string;
  id?: string;
  class?: string;
}

export function Switch(props: SwitchProps): JSX.Element {
  const { checked, onChange, disabled } = props;
  return (
    <button
      type="button"
      role="switch"
      id={props.id}
      aria-checked={checked}
      aria-label={props["aria-label"]}
      aria-labelledby={props["aria-labelledby"]}
      aria-describedby={props["aria-describedby"]}
      disabled={disabled}
      onClick={() => onChange(!checked)}
      class={`group inline-flex min-h-[44px] min-w-[44px] shrink-0 items-center justify-center sm:min-h-0 sm:min-w-0 focus:outline-none focus-visible:ring-0 disabled:cursor-not-allowed disabled:opacity-50 ${
        props.class ?? ""
      }`}
    >
      <span
        aria-hidden="true"
        class={`relative inline-flex h-6 w-11 items-center rounded-full border transition-colors group-focus-visible:ring-2 group-focus-visible:ring-[color:var(--color-primary)] group-focus-visible:ring-offset-2 group-focus-visible:ring-offset-[color:var(--color-surface-container-lowest)] ${
          checked
            ? "border-[color:var(--color-primary)] bg-[color:var(--color-primary)]"
            : "border-[color:var(--color-outline)] bg-[color:var(--color-surface-container-high)]"
        }`}
      >
        <span
          class={`inline-block size-4 rounded-full shadow-sm transition-transform motion-reduce:transition-none ${
            checked
              ? "translate-x-[22px] bg-[color:var(--color-on-primary)]"
              : "translate-x-[3px] bg-[color:var(--color-outline)]"
          }`}
        />
      </span>
    </button>
  );
}
